export default function getCards(state) {
  return state.games.taboo.cards;
}
